import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { delay } from '../../../Utility/Task/TaskQueue';
import { RenderSystemEvent } from '../../Render/RenderSystem';
import Scene from '../../../Scene/Scene';
import { PlaySound } from '../../Audio/AudioHelper';
import { AudioTrackType } from '../../Audio/AudioClip';
import Container from '../../../Prototype/Container';
import {
    StartAnimation,
    PlayAnimation,
    GetAnimationClip,
} from '../AnimationHelper';
import TransformComponent from '../../../Component/Transform';
import { defaultCanvasSize } from '../../../Constants/Canvas';
import Game from '../../../Game';
import RewardTextEffect from '../../../Prototype/Effect/RewardTextEffect';
import CoinBar, { hackForceCurrencyAnimation } from '../../../Prefabs/UI/HUD/CoinBar';

interface IRewardCoinsData {
    scene: Scene;
    value: number;
    previousValue: number;
}

export class RewardCoins extends AnimationClip<IRewardCoinsData> {
    public *execute(
        animator: GameObject,
        meta: IRewardCoinsData
    ): IterableIterator<number> {
        try {
            animator.scene.emit(RenderSystemEvent.BRING_TO_FRONT, animator);

            const text: GameObject = GameObject.findByName('coin_text')[0];

            const prevValueStr: string = meta.previousValue ? meta.previousValue.toFixed(0) : '0';
            (text.parent.parent as CoinBar).setCoinsText(prevValueStr);

            const coinsPanel: GameObject = GameObject.findByName('coin_bar')[0];

            const rewardEffectContainer = GameObject.Instantiate(Container);
            const rewardTransform: TransformComponent = rewardEffectContainer.getComponent(
                TransformComponent
            );

            coinsPanel.addChild(rewardEffectContainer);
            animator.addChild(rewardEffectContainer);
            rewardTransform.x = defaultCanvasSize.x / 2;
            rewardTransform.y = defaultCanvasSize.y / 2;

            StartAnimation(rewardEffectContainer, 'RewardCoinsEffect', {
                value: 3, // amount of coins
                texture: 'coin-reward',
                targetPosition: coinsPanel.container.position,
            });

            const localeText = `+${Game.locale.getText('RewardCoins')}`;
            rewardEffectContainer.addChild(
                GameObject.Instantiate(RewardTextEffect, {
                    text: localeText.replace('[x]', meta.value.toString()),
                })
            );

            yield* delay(2000);
            rewardEffectContainer.destroy();

            PlaySound('coins-add');

            hackForceCurrencyAnimation();

            yield* PlayAnimation(
                GetAnimationClip('Counter', text.parent, {
                    startValue: meta.previousValue,
                    finalValue: meta.previousValue + meta.value,
                    onUpdateOverride: function() {
                        (text.parent.parent as CoinBar).setCoinsText(this.value.toFixed(0));
                    },
                })
            );
        } catch (e) {
            console.warn('RewardCoins failed:', e);
        }
    }
}
